export default "__VITE_ASSET__BsDBi6V1__"